import React, { ReactNode, createContext, useContext, useState } from "react";
import { DisplayConfigDTO } from "../../interfaces/DistplayConfigDTO";

interface DisplayContextProps {
    display: DisplayConfigDTO | null;
    setDisplays: (inp:DisplayConfigDTO) => void,
    getDisplays: () => DisplayConfigDTO | null,
    getDisplayProperty: <K extends keyof DisplayConfigDTO>(name: K) => any;
}

const DisplayContext = createContext<DisplayContextProps | undefined>(
  undefined
);

interface DisplayProviderProps {
  children: ReactNode;
}
export const DisplayProvider:React.FC<DisplayProviderProps>  = ({children}) => {
    const [display,setDisplay] = useState<DisplayConfigDTO | null>(null);
   
    const setDisplays = (disp:DisplayConfigDTO) => {

      setDisplay(disp);

      localStorage.setItem("display_settings",JSON.stringify(disp));
    }
    const getDisplays = ():DisplayConfigDTO | null => {
      if (display === null){
       let dispSettings =  localStorage.getItem("display_settings");
       if (dispSettings){
        setDisplay(JSON.parse(dispSettings));
        return JSON.parse(dispSettings);
       }
      }
      return display;
    } 

    const getDisplayProperty = <K extends keyof DisplayConfigDTO>(keyName: K): DisplayConfigDTO[K] | null => {
      if (display === null) {
        return null;
      }
      if (keyName in display) {

        
        return display[keyName];
      }
      return null;
    };
    
   
   return (<DisplayContext.Provider value={{display,setDisplays,getDisplays,getDisplayProperty}}>
        {children}
    </DisplayContext.Provider>)
};

export const useDisplays = (): DisplayContextProps => {
  const context = useContext(DisplayContext);
  if (!context) {
    throw new Error("useFavorites must be used within a FavoritesProvider");
  }
  return context;
};
